import {ResponseStatus} from "../../actions/types";
import {PayloadAction} from "@reduxjs/toolkit";
import {PagingDataModel} from "../../pages/shared/models/paging-data.model";
import {OrderGroupSliceData} from "../slices/order-group.slice";

export function handleGetGroups(state: OrderGroupSliceData, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.FAIL:
            state.isLoading = false;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.SUCCESS:
            state.isLoading = false;

            state.data = payload && payload.orderGroups
                ? {...payload.orderGroups}
                : {groups: [], totalItems: 0, currentPage: 0, pageSize: 6}

            break;
    }
}

export function onPaginationChange (state: OrderGroupSliceData, action: PayloadAction<PagingDataModel>): void {
    state.data.pageSize = action.payload.pageSize;
    state.data.currentPage = action.payload.currentPage;
}